<template>
  <section class="p-3">
    <div class="row">
      <div class="col-3">
        <div class="card">
          <div class="card-header">
            ค้นหาบทสนทนาเก่า
          </div>
          <div class="card-body">
            <div class="form-group">
              <label for="">ค้นหา</label>
              <input type="search" class="form-control" placeholder="ชื่อ หรือบทสนทนา" v-model="queryParams.keyword">
            </div>
            <div class="form-group">
              <label for="platform">แพลตฟอร์ม</label>
              <select class="form-control" id="platform" v-model="queryParams.platform">
                <option :value="null">เลือกแพตฟอร์ม</option>
                <option value="line-customer">Line คุณลูกค้า</option>
                <option value="facebook-customer">Facebook คุณลูกค้า</option>
                <option value="line-professional">Line คุณแม่บ้าน</option>
                <option value="facebook-professional">Facebook คุณแม่บ้าน</option>
              </select>
            </div>
            <button class="btn btn-primary" @click="search()">ค้นหา</button>
          </div>
        </div>
      </div>
      <div class="col-9">
        <section v-if="archivedConversations">
          <h5 class="mb-3">ผลการค้นหา</h5>
          <div v-for="(archivedConversation, index) in archivedConversations" :key="index">
            <archived-conversation-item :archivedConversation="archivedConversation"></archived-conversation-item>
          </div>
        </section>
      </div>
    </div>

  </section>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import ArchivedConversationItem from '../components/archivedConversation/ArchivedConversationItem'

export default {
  components: {
    ArchivedConversationItem
  },
  data () {
    return {
      queryParams: {
        page: 0,
        keyword: null,
        platform: null
      }
    }
  },
  computed: {
    ...mapState('archivedConversation', ['archivedConversations', 'canLoadMore'])
  },
  methods: {
    ...mapActions('archivedConversation', ['fetchArchivedConversations']),
    async search () {
      await this.loadFirstArchivedConversations()
    },
    async loadFirstArchivedConversations () {
      this.queryParams.page = 0
      await this.fetchArchivedConversations(this.queryParams)
    },
    async loadMoreArchivedConversations () {
      this.queryParams.page = this.queryParams.page + 1
      await this.fetchArchivedConversations(this.queryParams)
    },
    async handleScroll (event) {
      if (((window.innerHeight + window.scrollY) >= document.body.scrollHeight) && this.canLoadMore) {
        await this.loadMoreArchivedConversations()
      }
    }
  },
  mounted () {
    this.$store.commit('archivedConversation/SET_ARCHIVED_CONVERSATIONS', null)
  },
  created () {
    window.addEventListener('scroll', this.handleScroll)
  },
  destroyed () {
    window.removeEventListener('scroll', this.handleScroll)
  }
}
</script>
